import * as React from "react";
const orangeCross = (props) => (
  <svg
    width={19}
    height={20}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.0455 2.69776L2.38037 18.3629C2.02355 18.7197 1.48724 18.7752 1.19732 18.4853C0.907409 18.1954 0.962889 17.6591 1.31971 17.3022L16.9848 1.6371C17.3417 1.28029 17.878 1.22481 18.1679 1.51472C18.4578 1.80463 18.4023 2.34095 18.0455 2.69776Z"
      fill="#B72000"
    />
    <path
      d="M18.0455 17.3024L2.38037 1.63722C2.02355 1.2804 1.48724 1.22492 1.19732 1.51484C0.907409 1.80475 0.962889 2.34106 1.31971 2.69788L16.9848 18.363C17.3417 18.7198 17.878 18.7753 18.1679 18.4854C18.4578 18.1955 18.4023 17.6592 18.0455 17.3024Z"
      fill="#B72000"
    />
  </svg>
);
export default orangeCross;